import { Building2, Plus } from 'lucide-react'
import { ShippingLocation_ } from 'src/api/db/apiShippingLocations'
import { Row } from 'src/shared/components/Semantic/all'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from 'src/shared/components/ui/card'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { ShippingLocationsTable } from './ShippingLocationsTable'

interface ShippingAddressesCardProps {
  locations: ShippingLocation_[]
  isLoading: boolean
  onAdd: () => void
  onEdit: (location: ShippingLocation_) => void
  onDelete: (id: number) => void
}

export const ShippingAddressesCard = ({
  locations,
  isLoading,
  onAdd,
  onEdit,
  onDelete,
}: ShippingAddressesCardProps) => {
  const { t } = useLocalization()

  return (
    <Card>
      <CardHeader>
        <Row className="items-center justify-between">
          <Row className="items-center gap-3">
            <Building2 className="h-5 w-5" />
            <div>
              <CardTitle>
                {t('Shipping addresses', 'Leveransadresser')}
              </CardTitle>
              <CardDescription>
                {t(
                  'Manage the physical locations where you can send and receive your products.',
                  'Hantera de fysiska platserna där du kan skicka och ta emot era produkter.'
                )}
              </CardDescription>
            </div>
          </Row>
          <Button onClick={onAdd} variant="primary">
            <Plus className="h-4 w-4 mr-2" />
            {t('New location', 'Lägg till ny')}
          </Button>
        </Row>
      </CardHeader>
      <CardContent>
        <ShippingLocationsTable
          locations={locations}
          isLoading={isLoading}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </CardContent>
    </Card>
  )
}
